import React from 'react'
import CareerDetails from '../CareerDetails'
import jobList from './positionList.json'

const BackendDeveloper = () => {
  return <CareerDetails {...jobList[4]} />
}

export default BackendDeveloper
